import { InventoryHardware } from "../../api/api-generated";
import {
  numbersMatch,
  stringIncludesIgnoreCase,
} from "../../utils/comparisons";
import { truncateISOString } from "../../utils/dateTime";
import { AddForm, AddPartsForm, Filters } from "./inventoryTypes";

export const filterConstraintChecker = (
  name: string,
  value: string,
  filters: Filters
) => {
  if (name === "fromDateFilter") {
    if (filters.toDateFilter && filters.toDateFilter < value) return false;
  }
  if (name === "toDateFilter") {
    if (filters.fromDateFilter && filters.fromDateFilter > value) return false;
  }
  return true;
};

export const partsValidator = (item: AddPartsForm) => {
  if (!item.partName || !item.amount) return false;
  return true;
};

export const analyzerValidator = (item: AddForm) => {
  if (!item.serial || !item.hardwareType) return false;
  return true;
};

export const filterInventoryHardwareItem = (
  item: InventoryHardware,
  filters: Filters
): boolean => {
  if (
    filters.hardwareType &&
    !numbersMatch(filters.hardwareType.id, Number(item.hardwareTypeId))
  )
    return false;
  if (filters.serial && !stringIncludesIgnoreCase(item.serial, filters.serial))
    return false;
  if (
    filters.fromDateFilter &&
    (item.dateReceived === null ||
      truncateISOString(item.dateReceived) <
        truncateISOString(filters.fromDateFilter))
  )
    return false;
  if (
    filters.toDateFilter &&
    (item.dateReceived === null ||
      truncateISOString(item.dateReceived) >
        truncateISOString(filters.toDateFilter))
  )
    return false;
  // Remove analyzer from table if it currently has an associated demo
  if (item.demo) return false;
  return true;
};

export const inventoryHardwareMiddlware = (
  name: string,
  value: string,
  state: any,
  autoboxValue?: object,
  autoboxLabel?: string
) => {
  if (autoboxLabel) {
    if (autoboxLabel === "hardwareType") return { hardwareType: autoboxValue };
  }
  return {};
};
